// /**
//  * Warwhouse - Add
//  */

// React
import React, {useState, useContext, useEffect} from 'react';
// Context
import AuthContext from '../../../../authContext';

// react hook form
import {Controller, useForm} from 'react-hook-form';

// UI
import theme from '../../../../theme';
import {makeStyles, Theme, createStyles} from '@material-ui/core/styles';
import {
  TextField,
  Grid,
  Button,
  CircularProgress,
  Paper,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  DialogContent,
  IconButton,
  DialogActions,
  Dialog,
  FormHelperText,
  Card,
  CardHeader,
  CardContent,
  Divider,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from '../../../../components/Modal';
import AddItemsParcelsList from './addItemsParcelsList';
import AddItemsParcelsForm from './addItemsParcelsForm';
import AddInventoryItemsParcelsForm from './addInventoryItemsParcelsForm';
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from '@material-ui/pickers';
import jMoment from 'moment-jalaali';
import JalaliUtils from '@date-io/jalaali';

// Client SDK
import Client from 'client-sdk/src/client';
import {GetAllWarehousesRequestBuilder} from 'client-sdk/src/warehouses/warehouses';

// Type
import {
  Parcel,
  ParcelItems,
  PayloadCreate,
  SelectorProps,
} from '../../interfaces';
import {
  AddItemCreateParcel,
  AddInventoryItemCreateParcel,
} from '../../../parcels/interfaces';
import {Warehouse} from '../../../warehouses/interfaces';

// helpers'
import {
  flattenObject,
  removeEmptyValueObject,
  convertPersianDigit2English,
  checkHourisPast,
  disablePrevDateByHour,
} from '../../../../utils/helpers';
import {Product} from '../../../products/interfaces';
import {Variant} from '../../../products/interfaces';
import {createParcelsActions} from '../../../parcels/actions';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {createStructuredSelector} from 'reselect';
import {Store} from '../../../../redux/reducers';
import {
  makeSelectCountList,
  makeSelectError,
  makeSelectList,
  makeSelectLoading,
} from '../../../parcels/selectors';

import {useHistory} from 'react-router-dom';
import moment from 'moment';
import ListDimensions from '../../../orderPack/dimensionsList';
import MapPosition from '../../../centers/components/mapPosition';
import RonadIcons from '../../../../components/iconComponent';

jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true});

type Props = {
  create: (body: any) => void;
  onClose: () => void;
  warehouseId: number;
  createParcelsDispatch: (payload: PayloadCreate) => void;
};

type Inputs = {
  agentName: string;
  agentPhoneNumber: string;
  deliveryDate: string;
  pickAddress: string;
  pickDate: string;
  pickTime: string;
  deliveryTime: string;
  destinationId: number;
  deliveryType: string;
  id: number;
  items: ParcelItems[];
  deliveryStartTime: string;
  deliveryEndTime: string;
  sourceId: number;
  status: string;
  sourceWarehouseName: string;
  destinationWarehouseName: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      marginLeft: '20px',
      marginRight: '20px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.success.main,
      },
    },
    cancelTitle: {
      marginTop: '45px',

      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(1),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
    },
    margin: {
      // margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      color: '#8a8a8a',
      marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8a8a8a',
      marginRight: '8px',
      marginTop: '21px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      padding: '8px 24px 8px 50px',
      marginLeft: '-40px',
    },
    card: {
      marginBottom: '16px',
      overflow: 'visible',
      padding: '14px',
      paddingBottom: '0',
      width: '100%',
    },
  })
);

function useOnMount(handler: any) {
  return React.useEffect(handler, []);
}

function required(displayName: any) {
  return function validateRequired(value: any) {
    return value !== null || `${displayName} is required.`;
  };
}

function Add(props: Props) {
  const classes = useStyles();
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const {
    register,
    handleSubmit,
    errors,
    control,
    watch,
    setValue,
    getValues,
  } = useForm<Inputs>({
    defaultValues: {
      deliveryType: '',
      deliveryTime: '',
      deliveryDate: disablePrevDateByHour(14),
      pickDate: disablePrevDateByHour(14),
      pickTime: null,
      deliveryStartTime: null,
      deliveryEndTime: null,
    },
  });

  const [items, setItems] = useState<any>([]);
  const [item, setItem] = useState<any>({});
  const [deliveryType, setDeliveryType] = useState<any>('BOX');
  const [transportationType, setTransportationType] = useState<any>('PARTNER');
  const [itemDeleted, setItemDeleted] = useState<any>({});
  const [id, setId] = useState<any>(1);
  const [itemsInfo, setItemsInfo] = useState<any>([]);
  const [inventoryItems, setInventoryItems] = useState<any>([]);
  const [productObject, setProductObject] = useState<Product>({});
  const [variantObject, setVariantObject] = useState<Variant>({});
  const [hasExpirationDateTime, setHasExpirationDateTime] = React.useState(
    false
  );
  const [itemCount, setItemCount] = useState<any>(0);
  const [openAddItem, setOpenAddItem] = useState(false);
  const [openAddInventoryItem, setOpenAddInventoryItem] = useState(false);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [openAutocomplete, setOpenAutocomplete] = React.useState(false);
  const [destinationId, setDestinationId] = useState(0 as number);
  const [valueWarehouse, setValueWarehouse] = React.useState<Warehouse | null>(
    null
  );
  const [checkSubmit, setCheckSubmit] = React.useState(false as boolean);
  const [parcelsData, setParcelsData] = React.useState({});
  const [options, setOptions] = React.useState<Warehouse[]>([]);
  const [openDimensions, setOpenDimensions] = useState(false as boolean);
  const [openListDimensions, setOpenListDimensions] = useState(
    false as boolean
  );
  const [dimensions, setDimensions] = useState<any>([]);
  const [boxCount, setBoxCount] = useState('');
  const [totalBoxCount, setTotalBoxCount] = useState(0);
  const [latLng, setLatLng] = useState({lat: 0, lng: 0} as {
    lat: number;
    lng: number;
  });
  const [count, setCount] = useState('');
  const [length, setLength] = useState('');
  const [weight, setWeight] = useState('');
  const [height, setHeight] = useState('');
  const [size, setSize] = useState('');
  const loading = openAutocomplete && options.length === 0;

  React.useEffect(() => {
    let active = true;
    if (!loading) {
      return undefined;
    }

    (async () => {
      const token = localStorage.getItem('token') || '';
      const makeRequest = new GetAllWarehousesRequestBuilder()
        .params({
          'status.equals': 'ACTIVE',
          size: 100,
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      const warehouses = response.data as any;
      if (active) {
        setOptions(warehouses as Warehouse[]);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!openAutocomplete) {
      setOptions([]);
    }
  }, [openAutocomplete]);

  const addDimensions = () => {
    const newDimension = {
      count,
      length:size,
      width:size,
      height:size,
      weight
    };
    setDimensions([...dimensions, newDimension]);
    setCount('');
    setSize('');
    setWeight('');
  };

  useEffect(() => {
    let totalCount: any = 0;
    dimensions.forEach((dimension: any) => {
      totalCount += Number(dimension.count);
    });
    setTotalBoxCount(totalCount);
  }, [dimensions]);

  const checkButtonDisabled = () => {
    return !size || !weight || !count;
  };

  const handleCloseDimensions = () => {
    setOpenDimensions(false);
    setBoxCount('');
    setOpenListDimensions(false);
    setDimensions([]);
  };

  const setUpdateStatus = () => {
    setCheckSubmit(true);
  };

  const onSubmit = (data: Inputs) => {
    let ronadTransportationDTO,deliveryStartTime,deliveryEndTime;
    let {
      agentName,
      agentPhoneNumber,
      deliveryDate,
      deliveryTime,
      pickAddress,
      pickDate,
      pickTime,
      description
    } = data;

    ronadTransportationDTO = {
      lat: latLng.lat,
      lon: latLng.lng,
      pickAddress,
      pickDate,
      pickTime: pickTime?.substring(0, 2).concat(':00:00'),
    };

    if (transportationType === 'PARTNER') {
      ronadTransportationDTO = {};
      deliveryStartTime = convertPersianDigit2English(
        deliveryTime.substring(0, 2).concat(':00:00')
      )
      deliveryEndTime = convertPersianDigit2English(
        deliveryTime.substring(3, 5).concat(':00:00')
      )
    }else {
      deliveryDate = pickDate
      deliveryStartTime = convertPersianDigit2English(
        pickTime.substring(0, 2).concat(':00:00')
      )
      deliveryEndTime = convertPersianDigit2English(
        pickTime.substring(3, 5).concat(':00:00')
      )
    }

    addParcel({
      agentName: agentName ? agentName : null,
      agentPhoneNumber: agentPhoneNumber ? agentPhoneNumber : null,
      deliveryType,
      items,
      partnerId: authContext?.user?.partnerId,
      deliveryDate,
      transportationType,
      description,
      ronadTransportationDTO,
      deliveryStartTime,
      deliveryEndTime,
      destinationId,
      shippingDate: convertPersianDigit2English(moment().format('YYYY-MM-DD')),
    });
  };

  const addParcel = (body: any) => {
    setParcelsData(body);
    handleOpenCheckConfirm();
  };

  const createItemsToParcels = (body: AddItemCreateParcel) => {
    const {
      count,
      product,
      variant,
      boxCount,
      category,
      countOfBox,
      hasExpirationDate,
      unitCost,
      productionDate,
      expirationDate
    } = body;
    setHasExpirationDateTime(hasExpirationDate);
    setId(id + 1);
    setProductObject(product);
    setVariantObject(variant);
    setItemCount(count);
    const idItem = product?.id;
    const variantId = variant?.id;
    const name = product?.name;
    setItemsInfo([
      ...itemsInfo,
      {
        id,
        productId: idItem,
        count,
        name,
        boxCount,
        countOfBox,
        product,
        variant,
      },
    ]);

    if (variantId) {
      setItem({
        variantId,
        count,
        packageCount: boxCount ?? 1,
        packageAmount: countOfBox ?? Number(count),
      });
    } else {
      setItem({
        productId: idItem,
        count,
        packageCount: boxCount ?? 1,
        packageAmount: countOfBox ?? Number(count),
      });
    }
    setItems([
      ...items,
      {
        variantId,
        productId: idItem,
        count,
        packageCount: boxCount ?? 1,
        packageAmount: countOfBox ?? Number(count),
        inventoryItems: [
          {
            amount: Number(count),
            unitCost: unitCost ?? 0,
            productionDate: hasExpirationDate ? productionDate : null,
            expirationDate: hasExpirationDate ? expirationDate : null,
          },
        ],
      },
    ]);
    setOpenAddItem(false);
  };

  const createInventoryItemsToParcels = (
    body: AddInventoryItemCreateParcel[]
  ) => {
    setInventoryItems(body);
    setItems([...items, {...item, inventoryItems: body}]);
    setOpenAddInventoryItem(false);
    setOpenAddItem(false);
  };

  const setConfirmDelete = (body: any) => {
    setOpenConfirmDelete(true);
    setItemDeleted(body);
  };

  const handleOpenCheckConfirm = () => {
    if (transportationType === 'PARTNER') {
      setCheckSubmit(true);
    } else {
      setOpenDimensions(true);
    }
  };

  const handleCloseCheckConfirm = () => {
    setCheckSubmit(false);
  };

  const handleClose = () => {
    setOpenConfirmDelete(false);
    setCheckSubmit(false);
  };

  const handleChangeDeliverType = (
    event: React.ChangeEvent<{value: unknown}>
  ) => {
    setDeliveryType(event.target.value as string);
  };

  const deleteItemsToParcels = () => {
    const newValue = items.filter((item: any) => item.id !== itemDeleted.id);
    const newValueInfo = itemsInfo.filter(
      (item: any) => item.id !== itemDeleted.id
    );

    setItems(newValue);
    setItemsInfo(newValueInfo);
    setOpenAddItem(false);
    handleClose();
  };

  const handleCreateParcel = () => {
    const parcelData = {...parcelsData, parcelPackages: dimensions};
    props.createParcelsDispatch({
      body: parcelData,
      pagination: {
        sourceWarehouseId: {equals: authContext.user?.warehouseId},
      },
      callback: () => {
        setParcelsData({});
        history.push('/seller-parcels');
      },
    });
    handleCloseDimensions();
    setCheckSubmit(false);
  };

  const handleDeliveryDateChange = (date: any) => {
    setValue(
      'deliveryDate',
      convertPersianDigit2English(date.format('YYYY-MM-DD'))
    );
    setValue('deliveryTime', '');
  };

  const handlePickDateChange = (date: any) => {
    setValue(
      'pickDate',
      convertPersianDigit2English(date.format('YYYY-MM-DD'))
    );
  };

  const handlePickTimeChange = (date: any) => {
    setValue(
      'pickTime',
      convertPersianDigit2English(date.format('YYYY-MM-DD HH:mm:ss'))
    );
  };

  useOnMount(() => {
    register(
      {name: 'deliveryDate', type: 'text'},
      {validate: required('تاریخ تحویل را وارد کنید')}
    );
    register({name: 'pickDate', type: 'text', defaultValue: ''});
    register({name: 'pickTime', type: 'text', defaultValue: ''});
  });

  const values = getValues();

  return (
    <>
      <Grid
        style={{
          zIndex: 3,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '71px',
        }}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            width: '100%',
            borderRadius: '0',
          }}
        >
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              {`
        ایجاد محموله 
        `}
            </Typography>
          </div>
        </Paper>
      </Grid>

      <form style={{display: 'flex'}} onSubmit={handleSubmit(onSubmit)}>
        <Grid
          container
          style={{margin: '8px 0'}}
          spacing={5}
          alignItems="flex-start"
        >
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات محموله
                </Typography>
              }
            />
            <CardContent>
            {transportationType === 'RONAD' ? <Grid container xs={12} sm={12} lg={12} spacing={2}>
                  <Grid container item xs={9} sm={9} lg={9} spacing={2}>
                    <Grid item xs={4} sm={4} lg={4} spacing={2}>
                      <div className={classes.item}>
                        <FormControl fullWidth variant="outlined">
                          <InputLabel id="transportationTypeLabel">
                            نوع ارسال
                          </InputLabel>
                          <Select
                            label="نوع ارسال"
                            fullWidth
                            id="transportationType"
                            name="transportationType"
                            inputProps={{
                              name: 'transportationType',
                              id: 'transportationType',
                            }}
                            labelId="transportationTypeLabel"
                            value={transportationType}
                            onChange={e =>
                              setTransportationType(e.target.value)
                            }
                            inputRef={register({ required: true })}
                          >
                            <MenuItem value={'PARTNER'} data-cy="fromPartner">
                              ارسال توسط خودم
                            </MenuItem>
                            <MenuItem value={'RONAD'} data-cy="fromRonad">
                              ارسال توسط روناد
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </Grid>
                    <Grid item xs={4} sm={4} lg={4} spacing={2}>
                      <div className={classes.item}>
                        <span style={{ width: '100%' }}>
                          <MuiPickersUtilsProvider
                            utils={JalaliUtils}
                            locale="fa"
                          >
                            <DatePicker
                              inputVariant="outlined"
                              id="pickDate"
                              name="pickDate"
                              label="تاریخ تحویل به ناوگان"
                              format="jYYYY/jMM/jDD"
                              disablePast
                              disableToolbar
                              fullWidth
                              autoOk
                              okLabel={null}
                              cancelLabel={null}
                              defaultValue={null}
                              value={values.pickDate}
                              onChange={handlePickDateChange}
                              error={errors.hasOwnProperty('pickDate')}
                              helperText={
                                errors.pickDate && errors.pickDate.message
                              }
                            />
                          </MuiPickersUtilsProvider>
                        </span>
                      </div>
                    </Grid>
                    <Grid item xs={4} sm={4} lg={4} spacing={2}>
                      <div className={classes.item}>
                        <Controller
                          rules={{ required: true }}
                          style={{ width: '100%' }}
                          control={control}
                          name="pickTime"
                          label="بازه تحویل به ناوگان"
                          data-cy="pickTime"
                          as={
                            <TextField
                              variant="outlined"
                              select
                              fullWidth
                              error={
                                !!errors.pickTime && !!errors.pickTime
                              }
                            >
                              <MenuItem
                                disabled={checkHourisPast(
                                  9,
                                  values.pickDate
                                )}
                                value={'09-11'}
                                data-cy="time1"
                              >
                                {'9 الی 11'}
                              </MenuItem>
                              <MenuItem
                                disabled={checkHourisPast(
                                  11,
                                  values.pickDate
                                )}
                                value={'11-13'}
                                data-cy="time2"
                              >
                                {'11 الی 13'}
                              </MenuItem>
                              <MenuItem
                                disabled={checkHourisPast(
                                  14,
                                  values.pickDate
                                )}
                                value={'14-16'}
                                data-cy="time3"
                              >
                                {'14 الی 16'}
                              </MenuItem>
                            </TextField>
                          }
                        />
                      </div>
                      <FormHelperText error focused>
                        {errors?.pickTime &&
                          ' بازه تحویل به ناوگان الزامی میباشد'}
                      </FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container item xs={12} alignItems="flex-end">
                        <div className={classes.item}>
                          <div style={{ width: '100%' }}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              name="pickAddress"
                              id="pickAddress"
                              label="آدرس جمع آوری"
                              inputRef={register({ required: false })}
                              error={errors.pickAddress && true}
                            />
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12} spacing={2}>
                      <div className={classes.item}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          inputRef={register({ required: false })}
                          name='description'
                          label="توضیحات"
                          data-cy="warehouseAddress"
                        />
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container item xs={3} sm={3} lg={3}>
                      <Grid item xs={12}>
                        <MapPosition
                          style={{
                            height: '250px',
                            zIndex: 1,
                            border: 'solid 2px gray',
                            borderRadius: '4px',
                          }}
                          zoom={14}
                          center={{ lat: 35.6892, lng: 51.389 }}
                          position={latLng}
                          setLatlng={(latLng: { lat: number; lng: number }) => {
                            setLatLng(latLng);
                          }}
                        />
                      </Grid>
                  </Grid>
                </Grid> : <Grid container xs={12} sm={12} lg={12} spacing={2}>
                  <Grid container item xs={12} sm={12} lg={12} spacing={2}>
                    <Grid item xs={3} sm={3} lg={3} spacing={2}>
                      <div className={classes.item}>
                        <FormControl fullWidth variant="outlined">
                          <InputLabel id="transportationTypeLabel">
                            نوع ارسال
                          </InputLabel>
                          <Select
                            label="نوع ارسال"
                            fullWidth
                            id="transportationType"
                            name="transportationType"
                            inputProps={{
                              name: 'transportationType',
                              id: 'transportationType',
                            }}
                            labelId="transportationTypeLabel"
                            value={transportationType}
                            onChange={e =>
                              setTransportationType(e.target.value)
                            }
                            inputRef={register({ required: true })}
                          >
                            <MenuItem value={'PARTNER'} data-cy="fromPartner">
                              ارسال توسط خودم
                            </MenuItem>
                            <MenuItem value={'RONAD'} data-cy="fromRonad">
                              ارسال توسط روناد
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3} spacing={2}>
                      <div className={classes.item}>
                        <MuiPickersUtilsProvider
                          utils={JalaliUtils}
                          locale="fa"
                        >
                          <DatePicker
                            inputVariant="outlined"
                            id="deliveryDate"
                            name="deliveryDate"
                            label="تاریخ تحویل محموله"
                            format="jYYYY/jMM/jDD"
                            minDate={disablePrevDateByHour(14)}
                            fullWidth
                            disablePast
                            autoOk
                            okLabel={null}
                            cancelLabel={null}
                            value={values.deliveryDate}
                            onChange={handleDeliveryDateChange}
                            error={errors.hasOwnProperty('deliveryDate')}
                            // helperText={
                            //   errors.deliveryDate && errors.deliveryDate.message
                            // }
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                      <FormHelperText error focused>
                        {errors?.deliveryDate &&
                          'تاریخ تحویل محموله الزامی میباشد'}
                      </FormHelperText>
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3} spacing={2}>
                      <div className={classes.item}>
                        <Controller
                          rules={{ required: true }}
                          style={{ width: '100%' }}
                          control={control}
                          name="deliveryTime"
                          label="بازه تحویل محموله"
                          data-cy="deliveryTime"
                          as={
                            <TextField
                              variant="outlined"
                              select
                              fullWidth
                              error={
                                !!errors.deliveryTime && !!errors.deliveryTime
                              }
                            >
                              <MenuItem
                                disabled={checkHourisPast(
                                  9,
                                  values.deliveryDate
                                )}
                                value={'09-11'}
                                data-cy="time1"
                              >
                                {'9 الی 11'}
                              </MenuItem>
                              <MenuItem
                                disabled={checkHourisPast(
                                  11,
                                  values.deliveryDate
                                )}
                                value={'11-13'}
                                data-cy="time2"
                              >
                                {'11 الی 13'}
                              </MenuItem>
                              <MenuItem
                                disabled={checkHourisPast(
                                  14,
                                  values.deliveryDate
                                )}
                                value={'14-16'}
                                data-cy="time3"
                              >
                                {'14 الی 16'}
                              </MenuItem>
                            </TextField>
                          }
                        />
                      </div>
                      <FormHelperText error focused>
                        {errors?.deliveryTime &&
                          ' بازه تحویل محموله الزامی میباشد'}
                      </FormHelperText>
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3} spacing={2}>
                      <div className={classes.item}>
                        <TextField
                          variant="outlined"
                          fullWidth
                          inputRef={register({ required: false })}
                          name='description'
                          label="توضیحات"
                          data-cy="warehouseAddress"
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>}
            </CardContent>
          </Card>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات انبار مقصد
                </Typography>
              }
            />
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={3} sm={3} lg={3} spacing={2}>
                  <div className={classes.item}>
                    <Autocomplete
                      style={{width: '100%'}}
                      open={openAutocomplete}
                      onOpen={() => {
                        setOpenAutocomplete(true);
                      }}
                      onClose={() => {
                        setOpenAutocomplete(false);
                      }}
                      getOptionSelected={(option, value) =>
                        option.name === value.name
                      }
                      getOptionLabel={option => option.name}
                      options={options}
                      loading={loading}
                      onChange={(event: any, newValue: any | null) => {
                        setDestinationId(newValue?.id);
                        setValueWarehouse(newValue);
                      }}
                      renderInput={params => (
                        <TextField
                          variant="outlined"
                          {...params}
                          label="انبار مقصد"
                          inputRef={register({required: false})}
                          name="admin"
                          id="admin"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {loading ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                  </div>
                </Grid>
                <Grid item xs={9} sm={9} lg={9} spacing={2}>
                  <div className={classes.item}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      defaultValue={' '}
                      value={valueWarehouse?.address}
                      label="آدرس انبار"
                      inputProps={{readOnly: true}}
                    />
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات مسئول حمل
                </Typography>
              }
            />
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={3} sm={3} lg={3} spacing={2}>
                  <div className={classes.item}>
                    <div style={{width: '100%'}}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        id="agentName"
                        name="agentName"
                        label="نام  "
                        inputRef={register({required: false})}
                        error={errors.agentName && true}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={3} sm={3} lg={3} spacing={2}>
                  <div className={classes.item}>
                    <span style={{width: '100%'}}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        id="agentPhoneNumber"
                        name="agentPhoneNumber"
                        label="شماره همراه (۰۹۱۲۳۴۵۶۷۸۹)"
                        inputRef={register({required: false})}
                      />
                    </span>
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  کالاهای محموله
                </Typography>
              }
              action={
                <Button
                  style={{marginTop: '10px'}}
                  variant="outlined"
                  color="primary"
                  size="large"
                  startIcon={<RonadIcons name='plusCircleOutline' className='text-primary'/>}
                  onClick={() => {
                    setOpenAddItem(true);
                  }}
                >
                  {'افزودن کالا به محموله'}
                </Button>
              }
            />
            <CardContent style={{margin: '14px 0  0', padding: '0 0 12px 0'}}>
              <Grid container spacing={3}>
                {itemsInfo.length > 0 && (
                  <AddItemsParcelsList
                    data={itemsInfo}
                    deleteItem={(body: any) => setConfirmDelete(body)}
                  />
                )}
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid
          container
          lg={12}
          md={12}
          xs={12}
          spacing={2}
          style={{
            flexDirection: 'row-reverse',
            position: 'fixed',
            backgroundColor: '#D5DADD',
            bottom: '0',
            right: '75px',
            padding: '15px',
            zIndex: 2,
          }}
        >
          <Grid
            container
            style={{
              marginLeft: '5px',
              marginTop: '-4px',
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              size="medium"
              onClick={() => window.history.back()}
              style={{
                marginRight: 'auto',
              }}
            >
              {'انصراف'}
            </Button>

            <Button
              type="submit"
              size="medium"
              data-cy="search"
              autoFocus
              variant="contained"
              color="primary"
              disabled={
                Object.keys(flattenObject(removeEmptyValueObject({...watch()})))
                  .length === 0
              }
              style={{
                marginRight: '14px',
                marginLeft: '120px',
              }}
            >
              {'ذخیره محموله '}
            </Button>
          </Grid>
        </Grid>
      </form>

      <Dialog
        open={openConfirmDelete}
        fullWidth
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <RonadIcons name="times" size={0.8} />
              </IconButton>
            ) : null}
          </div>

          <div
            className={classes.cancelTitle}
          >{`آیا از حذف ${itemDeleted.name} از محموله اطمینان دارید؟`}</div>
          <Divider style={{width: '100%', margin: '16px 0  0'}} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{textAlign: 'center', marginBottom: '8px'}}
          >
            <Grid item xs={12}>
              <Button
                style={{margin: '8px'}}
                autoFocus
                onClick={handleClose}
                variant="outlined"
                color="primary"
                size="large"
              >
                {'انصراف'}
              </Button>
              <Button
                variant="contained"
                onClick={deleteItemsToParcels}
                size="large"
                color="primary"
              >
                {'حذف کالا'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        open={checkSubmit}
        onClose={handleCloseCheckConfirm}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <RonadIcons name="times" size={0.8} />
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {`ایا از ایجاد محموله برای انبار "${
              checkSubmit ? valueWarehouse?.name : ''
            }" مطمئنید؟`}
          </div>
          <Divider style={{width: '100%', margin: '16px 0  0'}} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{textAlign: 'center', marginBottom: '8px'}}
          >
            <Grid item xs={12}>
              <Button
                style={{margin: '8px'}}
                autoFocus
                onClick={handleCloseCheckConfirm}
                variant="outlined"
                color="primary"
                size="large"
              >
                {'انصراف'}
              </Button>
              <Button
                variant="contained"
                onClick={handleCreateParcel}
                size="large"
                color="primary"
              >
                {'ذخیره محموله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDimensions}
        onClose={handleCloseDimensions}
        fullWidth
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleCloseDimensions ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDimensions}
              >
                <RonadIcons name="times" size={0.8} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.addIcon}>
            <RonadIcons name='cubeOutline' size={4} />
          </div>
            <Grid container alignItems="center" spacing={1}>
              <Grid item xs={4}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    id="count"
                    name="count"
                    value={count}
                    onChange={e => setCount(e.target.value)}
                    label="تعداد"
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    id="weight"
                    name="weight"
                    value={weight}
                    onChange={e => setWeight(e.target.value)}
                    label="وزن(گرم)"
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    variant="outlined"
                    select
                    fullWidth
                    value={size}
                    label="سایز بسته‌بندی"
                    onChange={(e) => setSize(e.target.value)}
                    error={
                      !!errors.pickTime && !!errors.pickTime
                    }
                  >
                    <MenuItem
                      value={'10'}
                      data-cy="time1"
                    >
                      10-10-10 سانتی‌متر
                    </MenuItem>
                    <MenuItem
                      value={'15'}
                      data-cy="time2"
                    >
                      15-15-15 سانتی‌متر
                    </MenuItem>
                    <MenuItem
                      value={'20'}
                      data-cy="time3"
                    >
                      20-20-20 سانتی‌متر
                    </MenuItem>
                  </TextField>
                </Grid>
              {dimensions.length !== 0 && (
                <Grid item xs={12}>
                  <ListDimensions data={dimensions} modal />
                </Grid>
              )}
            </Grid>
          {/* <Divider style={{ width: '100%', margin: '16px 0  0' }} /> */}
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              style={{ textAlign: 'center', marginBottom: '8px' }}
            >
              <Grid item xs={6} style={{marginRight: "auto",marginLeft: "8px"}}>
                <Button
                  style={{ margin: '8px' }}
                  autoFocus
                  onClick={addDimensions}
                  variant="outlined"
                  color="primary"
                  disabled={checkButtonDisabled()}
                  size="large"
                  data-cy="addBox"
                >
                  اضافه کردن بسته
                </Button>
                <Button
                  variant="contained"
                  onClick={setUpdateStatus}
                  size="large"
                  data-cy="cancelAddProduct"
                  color="primary"
                  disabled={dimensions.length == 0}
                >
                  ثبت نهایی
                </Button>
              </Grid>
            </Grid>
        </DialogActions>
      </Dialog>

      <Modal
        maxWidth="sm"
        onClose={() => setOpenAddItem(false)}
        open={openAddItem}
        title={
          <Typography
            variant="h6"
            style={{ textAlign: 'center', marginTop: '20px' }}
          >
            افزودن کالا به محموله
          </Typography>
        }
        content={
          <AddItemsParcelsForm
            addItem={(body: AddItemCreateParcel) => createItemsToParcels(body)}
            addInventoryItem={(body: AddInventoryItemCreateParcel[]) =>
              createInventoryItemsToParcels(body)
            }
            onClose={() => setOpenAddItem(false)}
          />
        }
      />

      <Modal
        maxWidth="sm"
        onClose={() => setOpenAddInventoryItem(false)}
        open={openAddInventoryItem}
        title={
          <div className={classes.addIcon}>
            <RonadIcons name='box'
              size={4}
              className='text-green'
            />
          </div>
        }
        content={
          <AddInventoryItemsParcelsForm
            product={productObject}
            variant={variantObject}
            count={itemCount}
            hasExpirationDate={hasExpirationDateTime}
            addItem={(body: AddInventoryItemCreateParcel[]) =>
              createInventoryItemsToParcels(body)
            }
            onClose={() => setOpenAddInventoryItem(false)}
          />
        }
      />
    </>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  parcelsList: makeSelectList(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    createParcelsDispatch: (payload: PayloadCreate) =>
      dispatch(createParcelsActions(payload)),
  };
}
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Add);
